import { fillString } from '@local_modules/generic/string-template.js'
import htmlTemplate from './show-one.html'
import { createElementFromHtml } from '@local_modules/generic/dom/create-elements-from-html.js'
import { callApi } from '@local_modules/generic/fetch'

export function makeOne (oneInvite) {
  console.log('showOneHtml', oneInvite)
  const inviteLink = `${location.protocol}//${location.host}/app/invite/${oneInvite.id}`

  const inviteHtml = fillString(htmlTemplate, {
    invitedEmail: oneInvite.email,
    invitedDate: oneInvite.created_at,
    // invitedByName: oneInvite._invitedBy?.name + ' (' + oneInvite._invitedBy?.email + ')',
    inviteRights: oneInvite.rights,
    inviteLink
  })

  const inviteElement = createElementFromHtml(inviteHtml)
  addListeners(inviteElement, oneInvite)
  return inviteElement
}

function addListeners (inviteElement, oneInvite) {
  const deleteInvitationButton = inviteElement.querySelector('[data-action="deleteInvitation"]')
  deleteInvitationButton.addEventListener('click', function () {
    deleteInvitation(inviteElement, oneInvite)
  })
}

async function deleteInvitation (inviteElement, oneInvite) {
  console.log('deleteInvitation', oneInvite.id)
  const elementButton = inviteElement.querySelector('[data-action="deleteInvitation"]')
  elementButton.classList.add('is-loading')

  const apiEndpoint = '/api/user-invites/:inviteId/delete'
  const apiResponse = await callApi(apiEndpoint,
    {
      inviteId: oneInvite.id
    },
    {
      method: 'DELETE'
    })

  if (apiResponse === 1) {
    inviteElement.classList.add('is-hidden')
  } else {
    elementButton.classList.remove('is-loading')
    elementButton.classList.add('is-danger')
    elementButton.innerHTML = 'Error deleting invitation; Reload the page please.'
  }
}
